import TicketDetailsAdditionalDetails from './TicketDetailsAdditionalDetails';

export default TicketDetailsAdditionalDetails;
export { TicketDetailsAdditionalDetails };
